const resources = {
  'Sticker.MakeItRight': 'Make it right',
  'Sticker.MakeItMagic': 'Make it magic',
  'Sticker.MakeItWork': 'Make it work',
  'MaxLengthInfo.postfix': 'Characters',
  'DateRangePicker.startDatePlaceholder': 'Start date',
  'DateRangePicker.endDatePlaceholder': 'End date',
};

export const t = (key: string) => {
  return key in resources ? (resources as any)[key] : key;
};
